import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { verifyEmail } from '../api/authService';

const VerifyEmail = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('Verifying your email...');
  const [error, setError] = useState('');
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    verifyEmail(token)
      .then(data => {
        setStatus(data.message || 'Email successfully verified!');
      })
      .catch(err => {
        setError(err.message || 'Verification failed.');
      });
  }, [token]);

  return (
    <div>
      {error ? (
        <p style={{ color: 'red' }}>{error}</p>
      ) : (
        <p>{status}</p>
      )}
    </div>
  );
};

export default VerifyEmail;